import 'utils/otel/bootstrap';
import 'utils/analytics/bootstrap';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './scss/main.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from 'components/Context/AppContext';
import { BrowserRouter } from 'react-router-dom';
import ModalRenderer from 'components/Modals';
import { Toasts } from 'components/Global';
import { Provider } from 'react-redux';
import store from 'features/store';
import { FliptProvider } from '@flipt-io/flipt-client-react';
import AuthInitializer from 'components/AuthInitializer';
import { getConfig } from 'config/runtime';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FliptProvider
      namespace={getConfig('REACT_APP_FLIPT_NAMESPACE')}
      options={{
        url: 'https://flipt.getandride.dev/',
        authentication: {
          clientToken: getConfig('REACT_APP_FLIPT_API_TOKEN'),
        },
      }}
    >
      <Provider store={store}>
        <AuthInitializer>
          <AppProvider>
            <BrowserRouter>
              <App />
              <ModalRenderer />
              <Toasts />
            </BrowserRouter>
          </AppProvider>
        </AuthInitializer>
      </Provider>
    </FliptProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
